/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Instructions_Draft_RestoredInputs */



/**
* | output |
* | --- |
* | "Unsaved changes from your last visit were restored." |
*
* @param {Project_Instructions_Draft_RestoredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_instructions_draft_restored = /** @type {((inputs?: Project_Instructions_Draft_RestoredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Instructions_Draft_RestoredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht gespeicherte Änderungen von Ihrem letzten Besuch wurden wiederhergestellt.")
	return /** @type {LocalizedString} */ ("Unsaved changes from your last visit were restored.")
});